import tokens from '../dictionary-dist/tokens.json';

export const Tokens = {
  ...tokens,
  buttons: {
    button: {
      size: {
        sm: '2.25rem',
        lg: '3rem',
      },
      padding: '0 1rem',
    },
    iconButton: {
      size: {
        sm: '2.25rem',
        lg: '3rem',
      },
      padding: '0',
    },
  },
  inputs: {
    textField: {
      transform: {
        sm: '11px, 1px',
        lg: '11px, -5px',
      },
      size: {
        sm: '0.625rem 1rem',
        lg: '1rem 1rem',
      },
      border: {
        radius: '4px',
      },
    },
  },
  toast: {
    duration: 5000,
  },
  boxShadow: `0 0 0 2px ${tokens.eixods.colors.brand.primary[100]}`,
  breakpoints: {
    mobile: 360,
    tablet: 640,
    laptop: 1024,
    desktop: 1280,
  },
} as const;
